import { useCallback, useMemo } from 'react';
import {
  manageCreditPageRightSidePanelState,
  setActiveManageCreditsPanelView,
  useAppDispatch,
  useAppSelector,
} from 'src/store';
import { ManageCreditAccountRightSidePanelType } from 'src/types';

export const useManageCreditAccountPageRightPanel = () => {
  const { activePanelView } = useAppSelector(
    manageCreditPageRightSidePanelState,
  );
  const dispatch = useAppDispatch();

  const changeActivePanelView = useCallback(
    (value: ManageCreditAccountRightSidePanelType | null) => {
      dispatch(setActiveManageCreditsPanelView(value));
    },
    [dispatch],
  );

  return useMemo(
    () => ({
      activePanelView,
      changeActivePanelView,
    }),
    [activePanelView, changeActivePanelView],
  );
};
